const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const buildError = async (response) => {
	let message = `API Error: ${response.status} ${response.statusText}`;
	try {
		const payload = await response.json();
		if (payload?.error) {
			message = payload.error;
		}
	} catch (error) {
		// Ignore JSON parse failures.
	}
	return new Error(message);
};

export const postJson = async (path, body, options = {}) => {
	const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {}),
		},
		body: JSON.stringify(body),
		signal: options.signal,
	});

	if (!response.ok) {
		throw await buildError(response);
	}

	return response.json();
};

export const getJson = async (path, options = {}) => {
	const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {}),
		},
		signal: options.signal,
	});

	if (!response.ok) {
		throw await buildError(response);
	}

	return response.json();
};

export const patchJson = async (path, body, options = {}) => {
	const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {}),
		},
		body: JSON.stringify(body),
		signal: options.signal,
	});

	if (!response.ok) {
		throw await buildError(response);
	}

	return response.json();
};

export const getBackendBaseUrl = () => BACKEND_BASE_URL;
